var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRobot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "robot_svg__icon robot_svg__icon-tabler robot_svg__icon-tabler-robot",
  width: 24,
  height: 24,
  strokeWidth: 2,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3l-1-1v-3l1-1V9a2 2 0 0 1 2-2zM10 16h4"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 11.5,
  r: 0.5,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 11.5,
  r: 0.5,
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 7 8 3M15 7l1-4"
})));
export default SvgRobot;